import { useEffect, useState } from 'react';

const STORAGE_KEY = 'trackizy_status_display_style';
const EVENT = 'trackizy-status-display-style-change';

export const STATUS_DISPLAY_STYLES = ['icon', 'dotWithIcon', 'dotAndIcon'];
const DEFAULT_STYLE = 'icon';

function read() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (STATUS_DISPLAY_STYLES.includes(raw)) return raw;
  } catch { /* localStorage unavailable */ }
  return DEFAULT_STYLE;
}

export function setStatusDisplayStyle(value) {
  try {
    if (!STATUS_DISPLAY_STYLES.includes(value)) return;
    localStorage.setItem(STORAGE_KEY, value);
  } catch { /* localStorage unavailable */ }
  window.dispatchEvent(new CustomEvent(EVENT));
}

export default function useStatusDisplayStyle() {
  const [style, setStyle] = useState(read);

  useEffect(() => {
    const onChange = () => setStyle(read());
    window.addEventListener('storage', onChange);
    window.addEventListener(EVENT, onChange);
    return () => {
      window.removeEventListener('storage', onChange);
      window.removeEventListener(EVENT, onChange);
    };
  }, []);

  return { style, setStyle: setStatusDisplayStyle };
}
